import { ContentHeader } from "../components/ContentHeader";
import { Star } from "../components/Icons";
import { useApi } from "../hooks/useApi";
import { OPERATIONS } from "../nav";
import type { DashboardSearch } from "../api/types";

export function DashboardsTab() {
  const meta = OPERATIONS.find((e) => e.id === "dashboards")!;
  const { data, loading, error } = useApi<DashboardSearch>("/command-center/dashboards");

  if (loading) {
    return (
      <>
        <ContentHeader title={meta.label} description={meta.desc} />
        <div className="loading"><div className="loading-spinner" /><p>Loading dashboards from Grafana…</p></div>
      </>
    );
  }
  if (error || !data) {
    return (
      <>
        <ContentHeader title={meta.label} description={meta.desc} />
        <div className="empty">command-center-api not reachable.</div>
      </>
    );
  }
  if (data.status !== "ok") {
    return (
      <>
        <ContentHeader title={meta.label} description={meta.desc} />
        <div className="empty">
          {data.reason ?? "Grafana not configured"}<br />
          <span style={{ fontSize: 12.5, color: "var(--text-muted)" }}>
            Set <code>GRAFANA_TOKEN</code> in the API environment.
          </span>
        </div>
      </>
    );
  }
  if ((data.folders ?? []).length === 0) {
    return (
      <>
        <ContentHeader title={meta.label} description={meta.desc} count={0} />
        <div className="empty">No dashboards found.</div>
      </>
    );
  }

  return (
    <>
      <ContentHeader title={meta.label} description={meta.desc} count={data.total ?? 0} />
      {data.folders.map((f) => (
        <section key={`${f.title}-${f.id}`} style={{ marginBottom: 20 }}>
          <div className="section-header">
            <h2>{f.title || "General"}</h2>
            <span className="count">{f.dashboards.length}</span>
          </div>
          <div className="grid">
            {f.dashboards.map((d) => (
              <a key={d.uid} className="card"
                 href={d.url} target="_blank" rel="noopener noreferrer"
                 style={{ display: "flex", flexDirection: "column", gap: 8, textDecoration: "none" }}>
                <div className="card-head">
                  <div className="card-name">{d.title}</div>
                  {d.starred && (
                    <span className="kind-badge" title="Starred"
                          style={{ color: "var(--accent)", borderColor: "var(--accent-border)", display: "inline-flex", padding: "2px 6px" }}>
                      <Star size={12} />
                    </span>
                  )}
                </div>
                {d.tags && d.tags.length > 0 && (
                  <div className="card-meta">
                    {d.tags.slice(0, 4).map((t) => <span key={t} className="kind-badge">{t}</span>)}
                  </div>
                )}
              </a>
            ))}
          </div>
        </section>
      ))}
    </>
  );
}
